import { useContext } from 'react';
import { SettingsContext } from '@immediate_media/pocket-config';
/**
 * A hook to get the settings for the current site.
 *
 * @example
 * const settings = useSettings();
 */

var useSettings = function useSettings() {
  return useContext(SettingsContext);
};

export default useSettings;